import faceMatch from "@iso/assets/images/face-match.svg";
import FacebookIcon from "@iso/assets/images/icon/facebook.svg";
import LinkedinIcon from "@iso/assets/images/icon/linkedin.svg";
import TwitterIcon from "@iso/assets/images/icon/twitter.svg";
import YoutubeIcon from "@iso/assets/images/icon/youtube.svg";
import InstagramIcon from "@iso/assets/images/icon/instagram.svg";

export function SidePanel() {
  return (
    <div className="hidden md:flex flex-col items-center text-center justify-between h-[calc(100vh-70.22px)] overflow-auto">
      <div className="px-8 md:px-12 lg:px-16 xl:px-32 py-6 flex-shrink-0">
        <p className="text-center text-4xl xl:text-5xl font-small text-gray-800 leading-tight tracking-tight uppercase">
          FRAUD PREVENTION <br /> FOR BUSINESS OF ALL SIZES
        </p>
      </div>
      
      <div className="flex items-center justify-center px-8 md:px-12 lg:px-16 xl:px-32 flex-shrink-0">
        <img className="w-full max-w-[300px] md:max-w-[350px] lg:max-w-[400px] h-auto" src={faceMatch} alt="Fraud Prevention" />
      </div>
      
      <div className="px-4 flex-shrink-0">
        <p className="text-xl md:text-2xl lg:text-3xl font-small py-4 md:py-6">
          From hundreds to millions of transactions.
        </p>
      </div>
      
      <div className="flex flex-col md:flex-row gap-y-6 md:gap-x-8 lg:gap-x-12 xl:gap-x-16 items-center justify-center px-4 md:px-8 lg:px-16 xl:px-32 flex-shrink-0">
        <div className="pb-4 md:pb-6">
          <h1 className="text-primary text-3xl md:text-4xl lg:text-5xl font-medium mb-2">100M+</h1>
          <span className="font-small">
            Transactions <br /> processed worldwide
          </span>
        </div>
        <div className="pb-4 md:pb-6">
          <h1 className="text-primary text-3xl md:text-4xl lg:text-5xl font-medium mb-2">3M+</h1>
          <span className="font-small">
            Anonymous profiles <br /> in Saffe Network
          </span>
        </div>
        <div className="pb-4 md:pb-6">
          <h1 className="text-primary text-3xl md:text-4xl lg:text-5xl font-medium mb-2">1M+</h1>
          <span className="font-small">
            Fraud attempts <br /> detected
          </span>
        </div>
      </div>
      
      <div className="bg-primary items-center rounded-t-[40px] md:rounded-t-[70px] py-4 md:py-5 w-full flex-shrink-0">
        <span className="text-white text-sm md:text-base">©{new Date().getFullYear()} Saffe. All rights reserved.</span>
        <div className="flex items-center justify-center px-8 md:px-16 lg:px-24 xl:px-36">
          <hr className="h-px w-full my-4 md:my-6 bg-white border-0" />
        </div>
        <div className="flex justify-center items-center gap-x-6 md:gap-x-8 lg:gap-x-10">
          <a
            href={"https://www.facebook.com/SaffeAI"}
            target="_blank"
            rel="noreferrer"
            className="transition-opacity hover:opacity-70"
          >
            <img
              className="w-auto h-auto"
              alt="Facebook"
              width={16}
              src={FacebookIcon}
            />
          </a>
          <a
            href={"https://www.linkedin.com/company/saffeai"}
            target="_blank"
            rel="noreferrer"
            className="transition-opacity hover:opacity-70"
          >
            <img
              className="w-auto h-auto"
              alt="LinkedIn"
              width={16}
              src={LinkedinIcon}
            />
          </a>
          <a
            href={"https://twitter.com/saffeai"}
            target="_blank"
            rel="noreferrer"
            className="transition-opacity hover:opacity-70"
          >
            <img
              className="w-auto h-auto"
              alt="Twitter"
              width={16}
              src={TwitterIcon}
            />
          </a>
          <a
            href={"https://www.youtube.com/@saffeai"}
            target="_blank"
            rel="noreferrer"
            className="transition-opacity hover:opacity-70"
          >
            <img
              className="w-auto h-auto"
              alt="YouTube"
              width={16}
              src={YoutubeIcon}
            />
          </a>
          <a
            href={"https://www.instagram.com/saffe.ai"}
            target="_blank"
            rel="noreferrer"
            className="transition-opacity hover:opacity-70"
          >
            <img
              className="w-auto h-auto"
              alt="Instagram"
              width={16}
              src={InstagramIcon}
            />
          </a>
        </div>
      </div>
    </div>
  );
}

